<div class="flex flex-col md:flex-row min-h-screen bg-white">
  <!-- Sidebar para desktop -->
  <app-sidebar [circleNumber]="3" (backClick)="goBack()" class="bg-teu-purple hidden sm:block relative w-full md:w-[197px] h-[120px] md:h-auto flex-shrink-0 overflow-hidden"></app-sidebar>
  <!-- Header para móvil -->
  <app-header [circleNumber]="3" (backClick)="goBack()"></app-header>

  <div class="flex-1 flex flex-col">
    <app-subheader [circleNumber]="3" class="pt-[60px] md:pt-0"></app-subheader>
    <!-- Contenedor principal -->
    <div
      class="w-full xl:max-w-[800px] mx-auto px-4 sm:px-6 md:px-8 pb-28 md:pb-16"
      style="padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 88px);"
    >
      <h1 class="text-2xl md:text-[32px] font-bold text-center mb-6">
        Validar mi identidad
      </h1>

      <h2 class="text-lg md:text-xl font-semibold text-center mb-2">
        Prueba de vida y captura facial
      </h2>
      <p class="text-sm text-gray-700 text-center max-w-[560px] mx-auto mb-8">
        Para realizar la prueba de vida y captura facial es importante tener buena iluminación y el enfoque de la
        cámara de tu celular directamente en tu rostro. Evitar moverse o hacer movimientos bruscos.
      </p>

      <h2 class="text-lg md:text-xl font-semibold text-center mb-2">
        Foto INE/IFE
      </h2>
      <p class="text-sm text-gray-700 text-center max-w-[560px] mx-auto mb-6">
        Para continuar con tu solicitud, es necesaria una foto de tu INE vigente por ambos lados.
      </p>

      <div class="flex justify-center mb-10">
        <!-- Ilustración simple de credencial -->
        <svg width="220" height="140" viewBox="0 0 220 140" class="drop-shadow">
          <rect x="5" y="10" rx="12" ry="12" width="210" height="120" fill="#ffffff" stroke="#e5e7eb" stroke-width="2"/>
          <rect x="20" y="30" width="64" height="64" rx="8" fill="#f3f4f6"/>
          <circle cx="52" cy="62" r="16" fill="#93c5fd"/>
          <rect x="100" y="40" width="90" height="10" rx="5" fill="#e5e7eb"/>
          <rect x="100" y="60" width="70" height="10" rx="5" fill="#e5e7eb"/>
          <rect x="100" y="80" width="80" height="10" rx="5" fill="#e5e7eb"/>
        </svg>
      </div>

      <div class="flex justify-center">
        <button type="button" class="btn-primary w-full max-w-[300px] h-[46px]" (click)="onConfirm()">
          Confirmar
        </button>
      </div>
    </div>
  </div>
</div>